{
  "en": {
    "meta": {
      "description": "FleetYards.net, Your Database for all Information related to Ships from “Star Citizen“."
    },
    "model": {
      "focus": "Focus",
      "classification": "Classification",
      "size": "Size",
      "beam": "Beam",
      "cargo": "Cargo",
      "personalInventory": "Ship Inventory",
      "crew": "Crew",
      "speed": "Speed",
      "minCrew": "min. Crew",
      "maxCrew": "max. Crew",
      "scmSpeed": "SCM Speed",
      "scmSpeedBoosted": "SCM Speed Boosted",
      "reverseSpeedBoosted": "Reverse Speed Boosted",
      "maxSpeed": "Max Speed",
      "scm": "SCM",
      "max": "Max",
      "groundMaxSpeed": "Max Speed",
      "groundReverseSpeed": "Reverse Speed",
      "pitch": "Pitch",
      "pitchBoosted": "Pitch Boosted",
      "yaw": "Yaw",
      "yawBoosted": "Yaw Boosted",
      "roll": "Roll",
      "rollBoosted": "Roll Boosted",
      "price": "Price",
      "groundAcceleration": "Acceleration",
      "compare": {
        "groundMaxSpeed": "Max Ground Speed",
        "groundReverseSpeed": "Reverse Ground Speed",
        "groundAcceleration": "Ground Acceleration",
        "groundDeceleration": "Ground Deceleration"
      },
      "quantumFuelTankSize": "Quantum Fuel",
      "hydrogenFuelTankSize": "Fuel",
      "pledgePrice": "Pledge Price",
      "height": "Height",
      "length": "Length",
      "mass": "Mass",
      "manufacturer": "Manufacturer",
      "hardpoints": "Hardpoints",
      "weapons": "Weapons",
      "equipment": "Equipment",
      "variants": "Variants",
      "productionStatus": "Production Status",
      "propulsion": "Propulsion",
      "modular": "Modular",
      "soldAt": "Sold at?",
      "rentalAt": "Rental at?",
      "poweredByUex": "Powered by UEX",
      "lastUpdatedAt": "Last updated at?"
    },
    "component": {
      "manufacturer": "Manufacturer",
      "size": "Size"
    },
    "availability": {
      "soldAt": "Sold at",
      "boughtAt": "Bought at"
    },
    "resources": {
      "models": "Ships",
      "hardpoints": "Hardpoints",
      "images": "Images"
    },
    "pagination": {
      "previous": "Previous Page",
      "next": "Next Page",
      "gap": "&hellip;"
    }
  }
}
